module.exports = __webpack_public_path__ + "img/04-3-4数据分析.c7f66718.svg";